import { iconNames } from '@zapier/design-system';
import { COLOR_KEYS } from '../../constants';
import { videoConfig } from '../Video';
export const blockConfig = {
    name: 'Block',
    category: 'Zapier Blocks',
    canHaveChildren: true,
    hideFromInsertMenu: true,
    image: 'https://cdn.zappy.app/213f0a68702998508b364f372a5f2f5f.png',
    inputs: [
        {
            name: 'iconName',
            type: 'string',
            enum: ['', ...Object.keys(iconNames)],
        },
        {
            name: 'iconColor',
            type: 'string',
            enum: Object.values(COLOR_KEYS),
            showIf: (options) => !!options.get('iconName'),
        },
        {
            name: 'heading',
            type: 'string',
        },
        {
            name: 'description',
            type: 'richText',
        },
        {
            name: 'smallText',
            type: 'string',
        },
        {
            name: 'ctaText',
            type: 'string',
        },
        {
            name: 'ctaHref',
            type: 'string',
        },
        {
            name: 'secondaryCtaText',
            type: 'string',
        },
        {
            name: 'secondaryCtaHref',
            type: 'string',
        },
        {
            name: 'imageUrl',
            type: 'cloudinaryMediaLibrary',
        },
        {
            name: 'imageAltText',
            type: 'string',
        },
        {
            name: 'video',
            type: 'object',
            subFields: videoConfig.inputs,
        },
        {
            name: 'isLink',
            friendlyName: 'Make entire block clickable',
            type: 'boolean',
        },
        {
            name: 'isCentered',
            friendlyName: 'Center align content',
            type: 'boolean',
        },
    ],
};
export const blockV2Config = Object.assign(Object.assign({}, blockConfig), { name: 'BlockV2', hideFromInsertMenu: false, friendlyName: 'Block' });
//# sourceMappingURL=config.js.map